/**
 * 首页
 * 2018-4-24
 */
"use strict";
angular.module("adminLoginModule", [
	"backgroundPlayModule"
]).
controller("adminLoginCtrl", ["$scope", "$state", "$stateParams", "modalDialog", "httpService", "$q", function($scope, $state, $stateParams, modalDialog, httpService, $q) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化数据
	 * @return {[type]} [description]
	 */
	function initStatus() {
		httpService.notLogin = false;
		$scope.status = {
			verificationCode: "/mcnww/web/code/image.do?V=12345678"
		};
		$scope.data = {
			platformlogo: [],
			platformBackGround: [],
			platformBackGrounds: []
		};
	}
	/**
	 * [initData description] 初始化状态
	 * @return {[type]} [description]
	 */
	function initData() {
		getseconddomain().then(function() {});
		loadEncryptionLib().then(function() {
			encryptionMethods();
		});
		enterEvent();
	}
	/**
	 * [submit description] 提交登录
	 * @return {[type]} [description]
	 */
	$scope.submit = function() {
		var params = angular.copy($scope.data);
		params.password = encryptedString(bodyRSA(), params.password);
		httpService.http("/mcnww/web/user/login.do", params, "post", true, true).then(function(data) {
			// debugger;
			if(data.success) {
				sessionStorage.setItem('requestToken',data.requestToken);
				$state.go("index.homepage");
			} else {
				$scope.updateImg();
				modalDialog.success(data.message, "success", false, function() {}, function() {}, '', 'leftLogin');
			}
		});
	};
	/**
	 * [getseconddomain description]获得admin 登录配置信息
	 * 
	 * @return {[type]} [description]
	 */
	function getseconddomain() {
		var deffer = $q.defer();
		var params = {
			domainPrefix: '123'
		}
		httpService.http("/mcnww/web/tenant/getSecondDomain.do", params, "get").then(function(data) {
			if(data.data.platformlogo==null){
				$scope.data.platformlogo =['images/logo.png'];
			}else{
				$scope.data.platformlogo = JSON.parse(data.data.platformlogo);
			}
			if(data.data.platformName==null) {
				$scope.data.platformName = '通讯员平台';
			} else {
				$scope.data.platformName = data.data.platformName;
			}
			if(data.data.platformBackGround == null){
				$scope.data.platformBackGrounds = ['images/bg.jpg'];
			}else{
				$scope.data.platformBackGrounds = JSON.parse(data.data.platformBackGround);
			}
			deffer.resolve();
		});
		return deffer.promise;
	}
	/**
	 * [updateImg description] 更新验证码
	 * @return {[type]} [description]
	 */
	$scope.updateImg = function() {
		var imgArray = $scope.status.verificationCode.split("=");
		imgArray[1] = Math.random();
		$scope.status.verificationCode = imgArray.join("=");
	};

	function enterEvent() {
		function submit(event) {
			if(event.originalEvent.keyCode === 13) {
				$scope.submit();
			}
		}
		$("body").bind("keydown", submit);
		$scope.$on("$destroy", function() {
			$("body").unbind("keydown", submit);
		});
	}
	/**
	 * [encryptionMethods description] 加密方法
	 * @return {[type]} [description]
	 */
	function encryptionMethods() {
		$.ajax({
			url: "/mcnww/web/user/publicKey.do",
			dataType: "text",
			success: function(data) {
				$("#encryption").remove();
				$("body").append("<script id='encryption'>" + data + "</script>");
			}
		});
	}
	/**
	 * [loadEncryptionLib description] 加载加密依赖文件
	 * @return {[type]} [description]
	 */
	function loadEncryptionLib() {
		var deffer = $q.defer();
		LazyLoad.js(["static/rsa/RSA.js", "static/rsa/BigInt.js", "static/rsa/Barrett.js"], function() {
			deffer.resolve();
		});
		return deffer.promise;
	}
	/**
	 * [forgetPassword description] 忘记密码
	 * @return {[type]} [description]
	 */
	$scope.forgetPassword = function() {
		// httpService.http("/mcnww/web/user/resetpwd.do", "", "get").then(function(data) {
		//     console.log(data);
		// });
		window.open("/mcnww/web/user/resetpwd.do");
	};

}]);